import api from "@/services/modules/data";
import { handleWithErrorMessage } from "@/services/utils";
import {
  SET_BOOKING_TEMPLATE,
  SET_BOOKING_TEMPLATES,
  SET_COUNTRIES,
  SET_IS_FETCHING_DATA,
  SET_LOCATIONS,
  SET_REASONS_FOR_HIRE,
  SET_FIELD_NECESSITIES,
  SET_IS_FETCHING_FIELD_NECESSITIES,
  SET_PUBLISHING_SCHEDULE_TAGS,
  SET_TAGS,
  SET_IS_FETCHING_TAGS,
  SET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS,
  SET_IS_FETCHING_COST_CATEGORIES,
  SET_COST_CATEGORIES,
  SET_IS_FETCHING_SEXUAL_ORIENTATIONS,
  SET_SEXUAL_ORIENTATIONS,
  SET_IS_FETCHING_RELIGIONS,
  SET_RELIGIONS,
  SET_IS_FETCHING_MARITAL_STATUSES,
  SET_MARITAL_STATUSES,
  SET_LOCATION_GROUPINGS,
  SET_ETHNIC_GROUPS,
  SET_IS_FETCHING_GRADES,
  SET_GRADES,
  SET_IS_FETCHING_WORKING_HOURS,
  SET_WORKING_HOURS,
  SET_FUNCTIONS,
  SET_IS_FETCHING_FUNCTIONS,
  SET_CONTRACT_TYPES,
  SET_CONTRACT_TYPES_GROUPINGS,
  SET_IS_FETCHING_CONTRACT_TYPES,
  SET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS,
  SET_IS_FETCHING_WORKING_HOURS_GROUPINGS,
  SET_WORKING_HOURS_GROUPINGS
} from "@/store/modules/data/mutations";

export const FETCH_BOOKING_TEMPLATES = "FETCH_BOOKING_TEMPLATES";
export const FETCH_BOOKING_TEMPLATE = "FETCH_BOOKING_TEMPLATE";
export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export const FETCH_REASONS_FOR_HIRE = "FETCH_REASONS_FOR_HIRE";
export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_FIELD_NECESSITIES = "FETCH_FIELD_NECESSITIES";
export const FETCH_PUBLISHING_SCHEDULE_TAGS = "FETCH_PUBLISHING_SCHEDULE_TAGS";
export const FETCH_TAGS = "FETCH_TAGS";
export const FETCH_COST_CATEGORIES = "FETCH_COST_CATEGORIES";
export const FETCH_SEXUAL_ORIENTATIONS = "FETCH_SEXUAL_ORIENTATIONS";
export const FETCH_RELIGIONS = "FETCH_RELIGIONS";
export const FETCH_MARITAL_STATUSES = "FETCH_MARITAL_STATUSES";
export const FETCH_LOCATION_GROUPINGS = "FETCH_LOCATION_GROUPINGS";
export const FETCH_ETHNIC_GROUPS = "FETCH_ETHNIC_GROUPS";
export const FETCH_GRADES = "FETCH_GRADES";
export const FETCH_WORKING_HOURS = "FETCH_WORKING_HOURS";
export const FETCH_WORKING_HOURS_GROUPINGS = "FETCH_WORKING_HOURS_GROUPINGS";
export const FETCH_FUNCTIONS = "FETCH_FUNCTIONS";
export const FETCH_CONTRACT_TYPES = "FETCH_CONTRACT_TYPES";
export const FETCH_CONTRACT_TYPES_GROUPINGS = "FETCH_CONTRACT_TYPES_GROUPINGS";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_COMMENT_FILE = "ADD_COMMENT_FILE";
export const REMOVE_FILE = "REMOVE_FILE";

const dataActions = {
  async [FETCH_BOOKING_TEMPLATES]({ dispatch, commit }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getBookingTemplates(params),
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_BOOKING_TEMPLATES, data)
    });
  },
  async [FETCH_BOOKING_TEMPLATE]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getBookingTemplate(id),
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_BOOKING_TEMPLATE, data)
    });
  },
  async [FETCH_LOCATIONS]({ dispatch, commit }, params = {}) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getLocations(params),
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_LOCATIONS, data)
    });
  },
  async [FETCH_REASONS_FOR_HIRE]({ dispatch, commit }, organisationId) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getReasonsForHire(organisationId),
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_REASONS_FOR_HIRE, data)
    });
  },
  async [FETCH_COUNTRIES]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getCountries,
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_COUNTRIES, data)
    });
  },
  async [FETCH_FIELD_NECESSITIES]({ dispatch, commit }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getFieldNecessities(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_FIELD_NECESSITIES, isLoading),
      setDataFunction: ({ data }) => commit(SET_FIELD_NECESSITIES, data)
    });
  },
  async [FETCH_PUBLISHING_SCHEDULE_TAGS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getPublishingScheduleTags,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS, isLoading),
      setDataFunction: ({ data }) => commit(SET_PUBLISHING_SCHEDULE_TAGS, data)
    });
  },
  async [FETCH_TAGS]({ dispatch, commit }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getTaxonomies(params),
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_TAGS, isLoading),
      setDataFunction: ({ data }) => commit(SET_TAGS, data)
    });
  },
  async [FETCH_COST_CATEGORIES]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getCostCategories,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_COST_CATEGORIES, isLoading),
      setDataFunction: ({ data }) => commit(SET_COST_CATEGORIES, data)
    });
  },
  async [FETCH_SEXUAL_ORIENTATIONS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getSexualOrientations,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_SEXUAL_ORIENTATIONS, isLoading),
      setDataFunction: ({ data }) => commit(SET_SEXUAL_ORIENTATIONS, data)
    });
  },
  async [FETCH_RELIGIONS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getReligions,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_RELIGIONS, isLoading),
      setDataFunction: ({ data }) => commit(SET_RELIGIONS, data)
    });
  },
  async [FETCH_MARITAL_STATUSES]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getMaritalStatuses,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_MARITAL_STATUSES, isLoading),
      setDataFunction: ({ data }) => commit(SET_MARITAL_STATUSES, data)
    });
  },
  async [FETCH_LOCATION_GROUPINGS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getLocationGroupings,
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_LOCATION_GROUPINGS, data)
    });
  },
  async [FETCH_ETHNIC_GROUPS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getEthnicGroups,
      setLoadingFunction: isLoading => commit(SET_IS_FETCHING_DATA, isLoading),
      setDataFunction: ({ data }) => commit(SET_ETHNIC_GROUPS, data)
    });
  },
  async [FETCH_GRADES]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getGrades,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_GRADES, isLoading),
      setDataFunction: ({ data }) => commit(SET_GRADES, data)
    });
  },
  async [FETCH_WORKING_HOURS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getWorkingHours,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_WORKING_HOURS, isLoading),
      setDataFunction: ({ data }) => commit(SET_WORKING_HOURS, data)
    });
  },
  async [FETCH_WORKING_HOURS_GROUPINGS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getWorkingHoursGroupings,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_WORKING_HOURS_GROUPINGS, isLoading),
      setDataFunction: ({ data }) => commit(SET_WORKING_HOURS_GROUPINGS, data)
    });
  },
  async [FETCH_FUNCTIONS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getFunctions,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_FUNCTIONS, isLoading),
      setDataFunction: ({ data }) => commit(SET_FUNCTIONS, data)
    });
  },
  async [FETCH_CONTRACT_TYPES]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getContractTypes,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CONTRACT_TYPES, isLoading),
      setDataFunction: ({ data }) => commit(SET_CONTRACT_TYPES, data)
    });
  },
  async [FETCH_CONTRACT_TYPES_GROUPINGS]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getContractTypesGroupings,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS, isLoading),
      setDataFunction: ({ data }) => commit(SET_CONTRACT_TYPES_GROUPINGS, data)
    });
  },
  async [ADD_COMMENT]({ dispatch, commit }, data) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).addComment(data)
    });
  },
  async [ADD_COMMENT_FILE]({ dispatch, commit }, { id, data }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).addCommentFile(id, data)
    });
  },
  async [REMOVE_FILE]({ dispatch, commit }, url) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).removeFile(url)
    });
  }
};

export default dataActions;
